import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import { getCountries } from '../../routes/UserAction';

import { domainUrl, domain, timeFormat, reduceText } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function Countries() {
    const dispatch = useDispatch();

    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    const options2 = {
        loop: true,
        margin: 10,
        nav: true, // ✅ Enable navigation arrows
        dots: false, // Hide dots if not needed
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 3,
        navText: [
            "<i class='bi bi-arrow-left custom-arrow text-white'></i>",
            "<i class='bi bi-arrow-right custom-arrow text-white'></i>",
        ], // ✅ Custom arrows
    };

    const [countries, setCountries] = useState([]);

    const fetchCountries = () => {
        dispatch(getCountries())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setCountries(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchCountries();
    }, [])


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'country'}/>

        
        {/* <!--Countries Start --> */}
        <div className="container-fluid feature">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    <h4 className="" style={{color: 'gold'}}> EmyCountries</h4>
                    <h1 className="display-4 mb-4">Countries we are legally registered</h1>
                    {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam.
                    </p> */}
                </div>

                <OwlCarousel
                    className="feature-carousel owl-carousel"
                    {...options2}
                >
                {/* <div className="feature-carousel owl-carousel"> */}
                    {countries?.filter(el => el.type == 0)?.length ? countries.filter(el => el.type == 0).map((row) => (
                        <div key={row.id} className="feature-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="feature-img">
                                <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100"  alt=""/>
                            </div>
                            <div className="feature-content p-4">
                                <h4 className="mb-3">{row.name? row.name: ''}</h4>
                                <p className="mb-4">
                                    {row.about? row.about: ''}
                                </p>
                                <Link to={row.uuid? `/country?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Read More</span></Link>
                            </div>
                        </div>
                    )) : null}
                    
                {/* </div> */}
                </OwlCarousel>
                <div className="feature-shaps"></div>
            </div>
        </div>
        {/* <!-- Countries End --> */}

        <Footer/>
        </>
    );
}
